import { User } from '../models/User'
import { IPublicClientApplication } from '@azure/msal-browser'
import { authorizedGet } from '../utils/authUtils'
import { protectedResources } from '../authConfig'

export const fetchMyUser = async (
  instance: IPublicClientApplication
): Promise<User> => {
  const baseUrl = process.env.REACT_APP_BASE_API_URL
  return await authorizedGet(
    instance,
    `${baseUrl}/users/me`,
    protectedResources.scopes.read
  )
}
